module.exports = __webpack_public_path__ + "a895ee5b18e2b8f6a446f6423f6edae3.woff";